import {FETCH_SURGERY_SPECIALITY} from "./index" 

export const setSurgerySpeciality = (payload) => {
    return {
      type: FETCH_SURGERY_SPECIALITY,
      payload: payload
    };
  };